












import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

import DynamicDocumentCheckboxFieldTemplate from '../fields/dynamic-document-checkbox-field-template.vue';
import DynamicDocumentScreenWidthConfigurationTemplate from '../fields/dynamic-document-screen-width-configuration-template.vue';

@Component({
  name: 'dynamic-document-checkbox-brick-template',
  components: {
    DynamicDocumentScreenWidthConfigurationTemplate,
    DynamicDocumentCheckboxFieldTemplate
  }
})
export default class DynamicDocumentCheckboxBrickTemplate extends Vue {

  @Prop({required: true}) fieldConfig: DisguiseDto.DynamicDocumentFieldDtoV2 | undefined;

}
